module.exports = __webpack_public_path__ + "static/media/orangeCharcoal.bc438d2d.jpg";